import React from 'react';
import {Card, CardTitle} from 'material-ui/Card';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import EvaluatedOptionCard from '../components/EvaluatedOptionCard';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {SECTION_TITLES} from './AnswersList';
import CategorizedRefOptionList from "../components/CategorizedRefOptionList";


class ReferenceOptionsList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sortBy: "alphabetical"
    }
    this.handleSortChange = this.handleSortChange.bind(this);
  }

  render() {
    let sortBy = this.state.sortBy;
    if((sortBy === "tier" || sortBy === "inputCategory") && this.props.section !== "assessment"){
      sortBy = "alphabetical"; //catches if switching from assessment to other section while in a sort not supported by the other sections
    }
    let categories = this.props.categories;
    let options = this.props.options.map((o) => {
      return {
        ...o,
        category: categories.find((c) => c.id === o.category),
        inputCategory: categories.find((c) => c.id === o.inputCategory)
      }
    });
    let categoryLabel = this.props.section === "assessment" ? "Sort by Assessment Output" : "Sort by Category";

    return (
      <div>
        <Card style={{maxWidth: 800, margin: '0 auto', position: 'relative'}}>
          <CardTitle title={SECTION_TITLES[this.props.section] + " Options"} />
          {
          <SelectField style={{position: 'absolute', right: 10, top: 10}} value={sortBy} onChange={this.handleSortChange}>

              <MenuItem value={"alphabetical"} key={"alpha"} primaryText={"Sort by Option Name"} />
              <MenuItem value={"category"} key={"category"} primaryText={categoryLabel} />
              {this.props.section === "assessment" && <MenuItem value={"inputCategory"} key={"inputCat"} primaryText={"Sort by Assessment Category"} />}
              {this.props.section === "assessment" && <MenuItem value={"tier"} key={"tier"} primaryText={"Sort by Assessment 'Tier'"} />}

          </SelectField>
          }

        {
          sortBy === "alphabetical" ? options.map((option) => <EvaluatedOptionCard hideResults={true} key={option.id} {...option} />) :
          <div>
            <CategorizedRefOptionList
              categories={categories}
              options={options}
              filterValue={sortBy}
            >
              <EvaluatedOptionCard hideResults={true} />
            </CategorizedRefOptionList>
          </div>
        }
        </Card>
      </div>
    )
  }

  handleSortChange(e, index, value) {
    this.setState({
      sortBy: value
    })
  }
}


let mapStateToProps = (state, ownProps) => {
  var section = ownProps.params.section;
  return {
    options: state.options.filter((o) => o.section === section),
    categories: state.categories,
    section: section
  }
}

let mapDispatchToProps = (dispatch, ownProps) => {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReferenceOptionsList));
